import { createAsyncThunk } from "@reduxjs/toolkit";
import { UserPhoto } from "../../../@types/usePhotoGallery";

export const addCameraInfo = createAsyncThunk(
    "adduploadedCameraDocument",
    async (file: UserPhoto[]) => {
        return file
    }
  );